import { useTheme } from '@mui/material/styles';
import { SortingState } from '@tanstack/table-core';
import { getActiveTransactions } from '../../../Api';
import { Data } from '../../../Helpers/deal-pipelines';
import { Vendor } from '../../../Helpers/types';
import withData from '../../Data/withData';
import BaseView from '../common/BaseView';
import { columnsPVD, getColumns } from './config';

interface ViewProps {
    data?: Array<Data>;
    isLoading?: boolean;
    vendors?: Array<Vendor>;
    onReload?: () => void;
    menuExpanded: boolean;
    hiddenColumns?: Record<string, boolean>;
    defaultSorting?: SortingState;
}
function View(props: ViewProps) {
    const theme = useTheme();
    return (
        <BaseView
            columns={getColumns(theme)}
            columnsPVD={columnsPVD}
            hiddenColumns={{
                oid: false,
                bid: false,
                pid: false,
                did: false,
                rid: false,
                eid: false,
                vendorSalesRep: false,
                lastUpdated: false,
            }}
            defaultSorting={[
                {
                    id: 'lastUpdated',
                    desc: true,
                },
            ]}
            title="Active Transactions"
            subtitle="These are active companies that have progressed into final underwriting and contract creation."
            data={props?.data || []}
            isLoading={props?.isLoading || false}
            vendors={props?.vendors || []}
            onReload={props?.onReload || Function}
            {...props}
        ></BaseView>
    );
}

export default withData(View, getActiveTransactions);
